import { __rest } from "tslib";
import React, { forwardRef } from "react";
import { Header as HeaderV2 } from "./V2";
import { DesktopMenu } from "./DesktopMenu";
import { MobileMenu } from "./MobileMenu";
import { productLinks } from "./productLinks";
import { accountLinks as defaultAccountLinks, topLevelLinks as defaultTopLevelLinks } from "./links";
import * as S from "./styles";

var EHS_ROOT = "https://www.everlyhealthsolutions.com",
    logoLink = function logoLink(_ref) {
  var e = _ref.src,
      o = _ref.alt,
      _ref$width = _ref.width,
      n = _ref$width === void 0 ? 120 : _ref$width,
      _ref$height = _ref.height,
      t = _ref$height === void 0 ? 24 : _ref$height;
  var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  var l = arguments.length > 2 ? arguments[2] : undefined;
  var r = arguments.length > 3 ? arguments[3] : undefined;
  return React.createElement(S.LogoLink, {
    key: "logoLink",
    href: (l || i) + "/",
    as: r || void 0
  }, React.createElement("img", {
    src: e,
    alt: o,
    width: n,
    height: t
  }));
},
    seoLinks = function seoLinks(e) {
  return productLinks(e).map(function (e) {
    return React.createElement("a", {
      href: e.url,
      tabIndex: -1,
      key: "".concat(e.label, " - ").concat(e.tags)
    }, e.label);
  });
},
    Header = forwardRef(function (e, o) {
  var n, t;

  var i = e.loggedIn,
      l = e.isLoggingIn,
      r = e.logoSrc,
      s = e.logoAlt,
      _e$logoWidth = e.logoWidth,
      a = _e$logoWidth === void 0 ? "120" : _e$logoWidth,
      _e$logoHeight = e.logoHeight,
      u = _e$logoHeight === void 0 ? "24" : _e$logoHeight,
      c = e.className,
      g = e.cartComponent,
      m = e.onMenuOpen,
      d = e.onMenuClose,
      L = e.onSubMenuOpen,
      k = e.onSubMenuClose,
      p = e.onLogout,
      _e$root = e.root,
      M = _e$root === void 0 ? "" : _e$root,
      _e$ehsRoot = e.ehsRoot,
      h = _e$ehsRoot === void 0 ? EHS_ROOT : _e$ehsRoot,
      b = e.activeMembership,
      f = e.numOfMemberCredits,
      v = e.membershipState,
      _e$accountLinks = e.accountLinks,
      R = _e$accountLinks === void 0 ? defaultAccountLinks : _e$accountLinks,
      _e$topLevelLinks = e.topLevelLinks,
      C = _e$topLevelLinks === void 0 ? defaultTopLevelLinks(M) : _e$topLevelLinks,
      S = e.onMenuItemClick,
      I = e.logoUrl,
      O = e.renderLinkAs,
      H = __rest(e, ["loggedIn", "isLoggingIn", "logoSrc", "logoAlt", "logoWidth", "logoHeight", "className", "cartComponent", "onMenuOpen", "onMenuClose", "onSubMenuOpen", "onSubMenuClose", "onLogout", "root", "ehsRoot", "activeMembership", "numOfMemberCredits", "membershipState", "accountLinks", "topLevelLinks", "onMenuItemClick", "logoUrl", "renderLinkAs"]),
      A = {
    login: {
      label: (null === (n = null == C ? void 0 : C.login) || void 0 === n ? void 0 : n.label) || "Login",
      url: (null === (t = null == C ? void 0 : C.login) || void 0 === t ? void 0 : t.url) || "/login"
    },
    account: R
  },
      w = b && void 0 !== f && v ? {
    type: b,
    creditsAvailable: f,
    state: v
  } : void 0,
      E = React.createElement(MobileMenu, {
    key: "mobileMenu",
    loggedIn: i,
    isLoggingIn: l,
    accountLinks: A,
    topLevelLinks: C,
    membership: w,
    root: M,
    ehsRoot: h,
    onLogout: p,
    onMenuItemClick: S,
    renderLinkAs: O
  }),
      y = React.createElement(DesktopMenu, {
    key: "desktopMenu",
    loggedIn: i,
    isLoggingIn: l,
    accountLinks: A,
    topLevelLinks: C,
    membership: w,
    root: M,
    ehsRoot: h,
    onLogout: p,
    onMenuOpen: m,
    onMenuClose: d,
    onSubMenuOpen: L,
    onSubMenuClose: k,
    onMenuItemClick: S,
    renderLinkAs: O
  }),
      _ = logoLink({
    src: r,
    alt: s,
    height: +u,
    width: +a
  }, M, I, O);

  return React.createElement(HeaderV2, Object.assign({
    className: c,
    ref: o
  }, H), {
    mobile: [E, _, g],
    desktop: [_, y, g],
    hidden: seoLinks(M)
  });
});

export default Header;
export { Header, HeaderV2, MobileMenu, DesktopMenu, logoLink };